import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react';
import styles from './ReconResults.style';
import theme from '../../theme.style';

const ReconResults = ({ name, status }) => {
  return (
    <>
      <div
        className={styles.root}
        style={{
          background: status ? theme.palette.accentTealOpaque : theme.palette.accentErrorOpaque,
        }}
      >
        <Text
          className={styles.test}
          style={{ color: status ? theme.palette.accentTeal : theme.palette.accentError }}
        >
          {name}:{' '}
        </Text>
        <Text
          className={styles.status}
          style={{ color: status ? theme.palette.accentTeal : theme.palette.accentError }}
        >
          {status ? 'Pass' : 'Needs Review'}
        </Text>
      </div>
    </>
  );
};

ReconResults.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.bool.isRequired,
};

export default ReconResults;
